const livePreviewUrl = 'hemfixarna-partner.vercel.app';

const getDefaultApiUrl = () => {
  if (window.location.href.includes('vercel.app') && !window.location.href.includes(livePreviewUrl)) {
    return 'https://hemfixare.dev.afonso.se';
  } else {
    return 'https://hemfixarna.se';
  }
};

const getApiUrl = () => {
  if (typeof process !== 'undefined' && process.env && process.env.API_URL) {
    return process.env.API_URL;
  }

  return getDefaultApiUrl();
};

const getDefaultCreditSafeApiUrl = () => {
  if (window.location.href.includes('vercel.app')) {
    return 'https://hemfixare-lookup-dev.vercel.app/api';
  } else {
    return 'https://hemfixare-lookup.vercel.app/api';
  }
};

const getCreditSafeApiUrl = () => {
  if (typeof process !== 'undefined' && process.env && process.env.CREDIT_SAFE_API_URL) {
    return process.env.CREDIT_SAFE_API_URL;
  }

  return getDefaultCreditSafeApiUrl();
};

export { getApiUrl, getCreditSafeApiUrl };
